import { useEffect } from "react";

/**
 * Como FocusOnNavigate (Selector="h1") del portal actual también en la primera carga: blazor.web.js pone tabindex="-1"
 * al título si no lo tiene y lo enfoca sin desplazar. Así el primer Tab sigue después del título (en el cambio de clave,
 * el regreso al login queda antes y no recibe el foco primero). Se aplica cuando la pantalla ya dibujó su título.
 */
export function useFocusHeading(ready: boolean): void {
  useEffect(() => {
    if (!ready) return;
    const heading = document.querySelector<HTMLElement>("h1");
    if (!heading) return;
    if (!heading.hasAttribute("tabindex")) heading.tabIndex = -1;
    heading.focus({ preventScroll: true });
  }, [ready]);
}
